export type StoredImage = {
  src?: string
  altText?: string
}

export const expandImage = (
  image: string | StoredImage | undefined,
  altFallback?: string,
): StoredImage => {
  const fallbackAlt = altFallback ?? ''
  if (!image) {
    return { altText: fallbackAlt }
  }
  const raw = typeof image === 'string' ? image : image.src
  const src = raw?.trim() || undefined
  const altText =
    typeof image === 'string'
      ? fallbackAlt
      : image.altText?.trim() || fallbackAlt
  return { src, altText }
}
